import { AddressDto } from 'api/actor';
import { PropertyTypeEnum } from 'api/real-estate';

type TranslateFn = (key: string) => string;

/**
 * Formate une adresse en une seule ligne française.
 * Exemple : "12 rue de Paris, Bât. A, 75001 Paris, France"
 */
export const formatAddress = (address: AddressDto | undefined | null): string => {
  if (!address) return '';
  const parts = [
    address.line1,
    address.line2,
    address.line3,
    address.zipCode && address.city ? `${address.zipCode} ${address.city}` : address.city,
    address.country
  ].filter(Boolean);
  return parts.join(', ');
};

/**
 * Retourne le libellé traduit du type de bien immobilier.
 */
export const formatPropertyType = (
  type: PropertyTypeEnum | undefined,
  t: TranslateFn
): string => {
  if (type == null) return '';
  const typeMap: Record<PropertyTypeEnum, string> = {
    [PropertyTypeEnum.Apartment]: t('REAL_ESTATE.LABELS.APARTMENT'),
    [PropertyTypeEnum.House]: t('REAL_ESTATE.LABELS.HOUSE'),
    [PropertyTypeEnum.Commercial]: t('REAL_ESTATE.LABELS.COMMERCIAL'),
    [PropertyTypeEnum.Office]: t('REAL_ESTATE.LABELS.GARAGE')
  };
  return typeMap[type] ?? '';
};

/**
 * Formate un prix en euros avec le locale français.
 */
export const formatEuroPrice = (amount: number): string => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  }).format(amount);
};
